module.exports = __webpack_public_path__ + "img/1.e40e0eaa.svg";